module.exports = new __parcel__URL__("issue-breakdown.tpl.bf971f77.svg").toString();